import React from "react";
import "./feedbackSection.scss";

const FeedbackSection = () => {
  // Sample data for the feedback cards
  const feedbackData = [
    {
      title: "Score - 94",
      description: "Nose is stunning and NAILS pani puri"
    },
    {
      title: "Score - 94",
      description:
        "The aroma is lovely with cumin, chipotle, some nice fruity notes. The palate has lots of levels and the flavours are all very pure and authentic. You get salt and sweet which is really lovely. The lingering heat is lovely. It feels really well composed."
    },
    {
      title: "Score - 91",
      description:
        "This is so exciting as a product. The essence of the paani puri has been captured beautifully and there is a brilliant balance of sweet and sour. Some good chilli heat as well. There is a cooling element too, like a yoghurt and some beautiful cumin, coriander herb elements too. "
    },
    {
      title: "Score - 93",
      description: "cumin, cilantro, savory"
    }
  ];

  return (
    <section className="feedbackSection">
      <div className="feedbackContainer">
        <div className="feedbackHeader">
          <h2 className="feedbackTitle">Tharra Paani: Scores and Feedback</h2>
          <p className="feedbackSubtitle">
            Checkout how the judges felt about our Double-Gold Award-Winning
            Tharra Paani!
          </p>
        </div>

        <div className="feedbackCardsContainer">
          {feedbackData.map((feedback, index) => (
            <div className="feedbackCard" key={index}>
              <div className="cardContent">
                <div className="cardHeader">
                  <div className="headerDetails">
                    <h2 className="cardTitle">{feedback.title}</h2>
                  </div>
                </div>
                <div className="cardDetails">
                  <div className="recipientWrapper">
                    <div className="doubleLine">
                      <div className="line"></div>
                    </div>
                    <p className="cardRecipient">What they liked</p>
                    <div className="doubleLine">
                      <div className="line"></div>
                    </div>
                  </div>

                  <div className="descriptionWrapper">
                    <p className="cardDescription">{feedback.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
